import { Maybe, TeamMemberDetails } from '__generated__/api-types-and-hooks'

/**
 * Helper function to get display name for an attendee
 * If the email matches a team member, return their full name
 * Otherwise, return the email (external user)
 */
export const getAttendeeDisplayName = (
  email: string,
  teamMemberDetails?: Maybe<Array<Maybe<TeamMemberDetails>>>
): string => {
  if (!teamMemberDetails || !Array.isArray(teamMemberDetails)) {
    return email
  }

  // Try to find this email in team members
  const teamMember = teamMemberDetails.find(
    (member) => member?.email?.toLowerCase() === email.toLowerCase()
  )

  if (teamMember && (teamMember.firstName || teamMember.lastName)) {
    const fullName = `${teamMember.firstName || ''} ${teamMember.lastName || ''}`.trim()
    return fullName || email
  }

  return email
}

/**
 * Helper function to check if an email belongs to an internal user
 */
export const isInternalUser = (
  email: string,
  teamMemberDetails?: Maybe<Array<Maybe<TeamMemberDetails>>>
): boolean => {
  if (!teamMemberDetails || !Array.isArray(teamMemberDetails)) {
    return false
  }

  return teamMemberDetails.some((member) => member?.email?.toLowerCase() === email.toLowerCase())
}

/**
 * Helper function to get team member details by email
 */
export const getTeamMemberByEmail = (
  email: string,
  teamMemberDetails?: Maybe<Array<Maybe<TeamMemberDetails>>>
): TeamMemberDetails | null => {
  if (!teamMemberDetails || !Array.isArray(teamMemberDetails)) {
    return null
  }

  return (
    teamMemberDetails.find((member) => member?.email?.toLowerCase() === email.toLowerCase()) || null
  )
}
